<template>
  <el-select
    v-loading="requestLoading"
    :value="value"
    @input="inputtt"
    :multiple="multiple"
    clearable
    :placeholder="placeholder"
    :disabled="disabled"
    @change="changeHanlder"
    :style="{
      width: width,
    }"
  >
    <el-option
      v-for="item in enumList"
      :key="item.Name"
      :label="item.Desc"
      :value="item.Name"
      :disabled="getDisabled(item.Name)"
    >
    </el-option>
  </el-select>
</template>
  <script>
export default {
  name: "EnumSelect",
  props: {
    value: [Array, String],
    multiple: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "请选择用户类型",
    },
    width: {
      type: [Number, String],
      default: "180px",
    },
    enumName: [String],
    disabledName: [Array, String],
    disabled:{
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      requestLoading: true,
      enumList: [],
    };
  },
  methods: {
    getDisabled(name) {
      if (!this.disabledName) {
        return false;
      }
      if (typeof this.disabledName == "string") {
        return this.disabledName == name;
      } else {
        return this.disabledName.indexOf(name) > -1;
      }
    },
    inputtt(e) {
      this.$emit("input", e || null);
    },
    changeHanlder(val) {
      this.$emit("change", val);
    },
    async flushEnum() {
      this.requestLoading = true;
      let requestRes = await this.$api.enumByName(this.enumName);
      if (requestRes && requestRes.success) {
        this.enumList = requestRes.data;
      }
      setTimeout(() => {
        this.requestLoading = false;
      }, 200);
    },
  },
  mounted() {
    this.flushEnum();
  },
};
</script>
    <style scoped>
</style>


// WEBPACK FOOTER //
// src/components/qs/EnumSelect.vue